export default "__VITE_ASSET__GxaAgZCz__"